import { TranslationBreadcrumb } from "components/UI";
import { Page404 } from "./pages";

const notFoundRoutes = [
  {
    path: "*",
    element: <Page404 />,
    breadcrumb: () => <TranslationBreadcrumb name={"breadcrumb.404"} />,
  },
];

export default notFoundRoutes;
